const PageLoader = () => {
  return <div></div>;
};

export default PageLoader;